import { SEND_CLICKS } from "api/api";
import { useCallback } from "react";
import { isProdDomain } from "logging/logging";

export const useSendClick = () => {
  const sessionToken = sessionStorage.getItem('sessionToken')
  const loggingEnabled = isProdDomain()

  return useCallback(
    async (elementIdentifier, contextValue = "") => {
      if (!loggingEnabled || !sessionToken) return;

      try {
        const res = await fetch(SEND_CLICKS, {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ sessionToken, elementIdentifier, contextValue }),
        });

        if (!res.ok) console.error("Click send failed:", res.status);
        // else console.log("✅ Click sent for:", elementIdentifier);
      } catch (err) {
        console.error("❌ Error sending click for:", elementIdentifier, err);
      }
    },
    [loggingEnabled, sessionToken]
  );
};
